import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CondutorRepository } from '@data/condutor/condutor.repository';
import { MultaRepository } from '@data/multas/multa.repository';
import { CategoriaCNHRepository } from '@app/data/categoria-cnh/categoria-cnh.repository';
import { modal } from '@shared/alerts/modal/modal.alert';
import { Campo, FormComponent } from '@shared/components/form/form.component';
import { cpfValidator } from '@shared/validators/cpf.validator';
import { ApiResources } from '@constants/api-resources';

@Component({
  selector: 'app-add-condutor',
  templateUrl: './add-condutor.component.html',
  styleUrls: ['./add-condutor.component.scss']
})
export class AddCondutorComponent implements OnInit {
  multa: any = {};
  gestaoCondutores = false;
  condutor: any = {};
  messageCpf: any;
  isValidCpf: boolean = true;
  maxDate: any;
  createNewDriver: boolean = true;
  private codigoCondutor: string | undefined;

  protected camposDadosCondutor: Campo[] = [
    {
      name: 'cpf',
      label: 'CPF',
      type: 'text',
      mask: '000.000.000-00',
      width: '50%',
      onChange: (value: any) => this.getCondutorByCPF(value),
      validators: [Validators.required, cpfValidator],
    },
    {
      name: 'nomeCondutor',
      label: 'Nome',
      type: 'text',
      width: '50%',
      validators: [Validators.required],
    },
    {
      name: 'dataNascimento',
      label: 'Data de Nascimento',
      type: 'date',
      width: 'calc(100% / 3)',
      validators: [Validators.required],
    },
    {
      name: 'rg',
      label: 'RG',
      type: 'text',
      dateOptions: { icon: 'suffix' },
      width: 'calc(100% / 3)',
      validators: [Validators.required],
    },
    {
      name: 'orgaoEmissorRG',
      label: 'Órgão Emissor RG',
      type: 'text',
      width: 'calc(100% / 3)',
      validators: [Validators.required],
    },
  ];

  protected camposDadosCNH: Campo[] = [
    {
      name: 'habilitacao',
      label: 'Nº CNH',
      type: 'text',
      width: '50%',
      validators: [Validators.required],
    },
    {
      name: 'categoria',
      label: 'Categoria',
      type: 'text',
      width: '50%',
      validators: [Validators.required],
    },
    {
      name: 'validade',
      label: 'Validade',
      type: 'date',
      width: 'calc(100% / 3)',
      validators: [Validators.required],
    },
    {
      name: 'dataPrimeiraHabilitacao',
      label: 'Data Primeira Habilitação',
      type: 'date',
      width: 'calc(100% / 3)',
      validators: [Validators.required],
    },
    {
      name: 'orgaoEmissorHabilitacao',
      label: 'Órgão Emissor CNH',
      type: 'text',
      width: 'calc(100% / 3)',
      validators: [Validators.required],
    },
  ];

  @ViewChild('formCondutor') formCondutor: FormComponent | undefined;
  @ViewChild('formCNH') formCNH: FormComponent | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MatDialog,
    private _dialogRef: MatDialogRef<any>,
    private multaRepository: MultaRepository,
    private condutorRepository: CondutorRepository,
    private changeDetector: ChangeDetectorRef,
    private categoriaCnhRepository: CategoriaCNHRepository,
  ) {
    this.maxDate = new Date();
    this.multa = this.data;
  }
  protected get isFormValid() {
    return (
      this.formCondutor?.isValid &&
      this.formCNH?.isValid
    );
  }

  ngOnInit() {
  }

  /** Para evitar erros em ambiente de desenvolvimento */
  public ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  protected onSubmit(formCondutor: any, formCNH: any) {
    const body = { codigoMulta: this.multa.codigoMulta, codigoCondutor: this.codigoCondutor, ...formCondutor, ...formCNH };

    if (this.isFormValid) {
      this.multaRepository.basePath = ApiResources.MULTAS_CONDUTOR;
      if (this.createNewDriver) {
        this.multaRepository.postRequest(body).subscribe({
          next: () => {
            this._dialogRef.close(true);
            this.multaRepository.basePath = ApiResources.MULTAS;
          },
          error: () => {
            modal.fire({
              icon: 'error',
              title: 'Erro ao inserir o novo condutor',
              html: 'Tente novamente mais tarde por meio da inserção do novo condutor',
            });
            this.multaRepository.basePath = ApiResources.MULTAS;
          },
        });
      } else {
        this.multaRepository.putRequest('', body).subscribe({
          next: () => {
            this._dialogRef.close(true);
            this.multaRepository.basePath = ApiResources.MULTAS;
          },
          error: () => {
            modal.fire({
              icon: 'error',
              title: 'Erro ao atualizar o condutor',
              html: 'Tente novamente mais tarde por meio da inserção do novo condutor',
            });
            this.multaRepository.basePath = ApiResources.MULTAS;
          },
        });
      }
    }
  }

  //verifica se existe condutor com o cpf atual cadastrado
  getCondutorByCPF(cpf: string) {
    if (cpf?.length >= 11)
      this.condutorRepository.getByCPF(cpf).subscribe((result) => {
        if (result && this.formCondutor && this.formCNH) {
          const data = result.data;

          if (data.id) {
            this.createNewDriver = false;

            this.formCondutor.patchValue({
              nomeCondutor: data.pessoa.razaoSocial,
              dataNascimento: data.pessoa.dataNascimento,
              rg: data.pessoa.rg,
              orgaoEmissorRG: data.pessoa.orgaoEmissorRg,
            })

            this.formCNH.patchValue({
              habilitacao: data.numeroCNH,
              categoria: "",
              validade: data.dataValidadeCNH,
              dataPrimeiraHabilitacao: data.dataPrimeiraHabilitacao,
              orgaoEmissorHabilitacao: data.orgaoCNH,
            })
          }

          if (data.categoriaId) {
            let categoriaCnh = '';

            this.categoriaCnhRepository.getByIdRequest(`?codigoCategoria=${data.categoriaId}`).subscribe((result: any) => {
              categoriaCnh = result.data.results[0].sigla;
              
              this.formCNH?.patchValue({
                categoria: categoriaCnh,
              })
            })
          }

          this.codigoCondutor = data.id;
        } else {
          this.createNewDriver = true;
        }
      });
    else
      this.createNewDriver = true;
  }

  //fecha dialog
  close(): void {
    this._dialogRef.close();
  }
}
